import { computed, Injectable, signal } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { ROLES } from '../../constants/roles.constants';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class UserAccessService {
  userInfoService: any;
  userRole = signal(null);
  private downloadDataEnabled = signal(false);
  userId = signal<string>('');

  isAdmin = computed(() => this.userRole() === ROLES?.admin);
  isAnalyst = computed(() => this.userRole() === ROLES?.analyst);
  isClient = computed(() => this.userRole() === ROLES?.client);
  isSuperAdmin = computed(() => this.userRole() === ROLES?.superadmin);
  isRootAdmin = signal<boolean>(false);
  isDelegatedAdmin = signal<boolean>(false);
  // Id of the admin who delegated admin management to the current user.
  delegatedById = signal<string>('');
  canManageAdmins = computed(() => this.isRootAdmin() || this.isDelegatedAdmin());
  isDownloadDataEnabled = computed(() => {
    if (this.userRole() === ROLES?.client) {
      return this.downloadDataEnabled();
    }
    return true;
  });

  constructor(private keycloak: Keycloak) {
    const token = this.keycloak.token;
    if (token) {
      const decodedToken: any = jwtDecode(token);
      const userRole = decodedToken?.['resource_access']?.['resourcepanorama-be']?.roles?.[0];
      this.userRole.set(userRole);
      this.downloadDataEnabled.set(decodedToken?.['downloadDataEnabled']);
      const idFromToken = decodedToken?.sub ?? decodedToken?.['sub'] ?? decodedToken?.['id'] ?? '';
      this.userId.set(idFromToken || '');
      this.isRootAdmin.set(this.userId() === decodedToken?.['managed_by']);
      this.delegatedById.set(decodedToken?.['delegated_by'] ?? '');
      this.isDelegatedAdmin.set(this.isAdmin() && !!this.delegatedById());
    }
  }

  public canAccess(roles: string[]): boolean {
    if (roles) {
      const canAccess: (boolean | '')[] = roles.map(role => role && this.keycloak.hasRealmRole(role));
      return canAccess.includes(true);
    } else {
      return false;
    }
  }

  public getUserId(): string {
    return this.userId();
  }
}
